import React from 'react';

class NotFound extends React.Component {
  render() {
    return (
      <div className="NotFound" data-testid="page-not-found">
        <h1>NotFound</h1>
      </div>
    );
  }
}

export default NotFound;
